import React from 'react';
import './load.css';

function Spinner({ className = '', style = {} }) {
  return <span className={`loader ${className}`} style={{ ...style }}></span>;
}
export default Spinner;
